<template>
  <v-card outlined>

    <c-expansion-panel>
      <template v-slot:header="{ expand }">

        <v-row class="pa-3 align-center border-b--thin">
          <img class="mr-3" src="@/assets/img/illustrations/cream.png" height="40px" width="40px" />

          <div>
            
            <div v-if="item.isCustomRow">
              {{ item.name }}
            </div>
            <text-highlight v-else
            class="text-ellipsed" :queries="nameKeywords" highlightClass="white--text color1" highlightStyle="">{{ ( item.definition || {}).name }}</text-highlight>

            <div>
              <template v-if="item.items.length > 1">
                <span class="overline">
                  {{ item.items.length }} ITEMS
                </span>
              </template>
            </div>
          </div>
          <v-spacer></v-spacer>
          <c-ms-ii
          :metric_definition="item.definition" 
          :realValue.sync="totalQuantity"
          :key="(item.definition || {}).id"
          labelMode
          alwaysScale
          class="font-weight-bold"
          ></c-ms-ii>

          <v-icon :class="{'rotate-180': expand}">mdi-chevron-down</v-icon>
        </v-row>

      </template>
      <template v-slot:body>


        <div class="">
          <table :class="['final-table compact lines-b lines-r full-width']">
            <colgroup ref="colgroup1">
              <col width="8px" />
              <col width="8px" />
              <col width="8px" />
              <col width="8px" />
              <col width="8px" />
              <!--
              <col width="8px" />
              <col width="8px" />
              <col width="8px" />
              -->
            </colgroup>
            <tr class="caption">
              <th>RID</th>
              <th>Box count</th>
              <th>Quantity Per Box</th>
              <th>Total Quantity</th>
              <th>Weight</th>
              <!--
              <th>Unit price</th>
              <th>Total</th>
              <th>Discount (%)</th>
              -->
            </tr>
            <list-row
            v-for="item in item.items"
            vmode="group"
            :key="item.tempID"
            :item="item"
            :reserved="(savedInputs.find(row => row.id === item.id) || {}).quantity"
            :inventoryView="inventoryView"
            :mergeMap="mergeMap"
            :selected="selected"
            :searchFilters="searchFilters"
            :showAllBoxesMode="showAllBoxesMode"
            :boxOrderIDMap="boxOrderIDMap"
            class="caption"
            @checkRow="$emit('checkRow', item)"
            ></list-row>
          </table>
        </div>
      </template>
    </c-expansion-panel>
  
  </v-card>
</template>

<script>
import ListRow from "./list-row";
import TextHighlight from 'vue-text-highlight'

export default {
  data () {
    return {
    }
  },
  props: {
    item: {},
    selected: null,
    savedInputs: null,
    mergeMap: null,
    inventoryView: null,
    searchFilters: null,
    showAllBoxesMode: null,
    boxOrderIDMap: null
  },
  components: {
    ListRow,
    TextHighlight
  },
  computed: {
    nameKeywords () {
      return (this.searchFilters.name || '').trim().split(/\s+/)
    },
    totalQuantity () {
      return this.item.items.reduce((a, i) => a + i.quantity, 0)
    }
  }
}
</script>